var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPiano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 2560 l0 -1760 260 0 260 0 0 660 0 660 -68 0 c-119 0 -107 -126 -110 1121 l-2 1079 -170 0 -170 0 0 -1760z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 3237 c0 -1242 11 -1117 -98 -1117 l-62 0 0 -660 0 -660 260 0 260 0 0 660 0 660 -68 0 c-119 0 -107 -126 -110 1121 l-2 1079 -90 0 -90 0 0 -1083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 3237 c0 -1242 11 -1117 -98 -1117 l-62 0 0 -660 0 -660 260 0 260 0 0 1760 0 1760 -180 0 -180 0 0 -1083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2300 2560 l0 -1760 260 0 260 0 0 655 0 655 -55 0 c-65 0 -99 14 -114 47 -8 17 -11 331 -11 1093 l0 1070 -170 0 -170 0 0 -1760z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3070 3244 l0 -1076 -29 -29 c-26 -25 -37 -29 -85 -29 l-56 0 0 -655 0 -655 260 0 260 0 0 660 0 660 -68 0 c-119 0 -107 -126 -110 1121 l-2 1079 -85 0 -85 0 0 -1076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3660 3237 c0 -1242 11 -1117 -98 -1117 l-62 0 0 -660 0 -660 260 0 260 0 0 660 0 660 -68 0 c-119 0 -107 -126 -110 1121 l-2 1079 -90 0 -90 0 0 -1083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4260 3237 c0 -1242 11 -1117 -98 -1117 l-62 0 0 -660 0 -660 260 0 260 0 0 1760 0 1760 -180 0 -180 0 0 -1083z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPiano);
export default __webpack_public_path__ + "static/media/icon_piano.e86bbfda.svg";
export { ForwardRef as ReactComponent };